import { defineComponent, computed, ref, watch, nextTick } from "vue";
import { useI18n } from "../../../locales/index.mjs";
import TuiButton from "../../common/base/Button.vue.mjs";
import Dialog from "../../common/base/Dialog/index.mjs";
import Input from "../../common/base/Input/index.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import ArrowUpIcon from "../../common/icons/ArrowUpIcon.vue.mjs";
import useMemberControl from "./useMemberControlHooks.mjs";
import useMemberItem from "../MemberItem/useMemberItemHooks.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MemberControlPC",
  props: {
    userInfo: null,
    showMemberControl: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const {
      controlList,
      handleCancelDialog,
      handleAction,
      isDialogVisible,
      dialogData,
      tempUserName
    } = useMemberControl(props);
    const { isCanOperateMySelf } = useMemberItem(props.userInfo);
    const singleControl = computed(() => {
      return isCanOperateMySelf.value ? null : controlList.value[0];
    });
    const moreControlList = computed(() => {
      return isCanOperateMySelf.value ? controlList.value : controlList.value.slice(1);
    });
    const dropdownClass = ref("down");
    const moreBtnRef = ref();
    const operateListRef = ref();
    const showMoreControl = ref(false);
    watch(
      () => props.showMemberControl,
      (val) => {
        if (!val) {
          showMoreControl.value = false;
        }
      }
    );
    async function toggleClickMoreBtn() {
      if (showMoreControl.value) {
        showMoreControl.value = false;
      } else {
        await handleDropDownPosition();
        showMoreControl.value = true;
      }
    }
    async function handleDropDownPosition() {
      var _a, _b, _c;
      const { top, bottom } = (_a = moreBtnRef.value) == null ? void 0 : _a.getBoundingClientRect();
      const { top: containerTop, bottom: containerBottom } = (_b = document.getElementById("memberListContainer")) == null ? void 0 : _b.getBoundingClientRect();
      if (!containerBottom || !containerTop) {
        return;
      }
      const bottomSize = containerBottom - bottom;
      const topSize = top - containerTop;
      let dropDownContainerHeight = 0;
      if (!showMoreControl.value) {
        operateListRef.value.style = "display:block;position:absolute;z-index:-1000";
        await nextTick();
        dropDownContainerHeight = operateListRef.value.offsetHeight;
        operateListRef.value.style = "";
      } else {
        dropDownContainerHeight = (_c = operateListRef.value) == null ? void 0 : _c.offsetHeight;
      }
      if (topSize < dropDownContainerHeight) {
        return;
      }
      if (bottomSize < dropDownContainerHeight) {
        dropdownClass.value = "up";
      }
    }
    return { __sfc: true, props, t, controlList, handleCancelDialog, handleAction, isDialogVisible, dialogData, tempUserName, isCanOperateMySelf, singleControl, moreControlList, dropdownClass, moreBtnRef, operateListRef, showMoreControl, toggleClickMoreBtn, handleDropDownPosition, TuiButton, Dialog, TuiInput: Input, SvgIcon, ArrowUpIcon };
  }
});
export {
  _sfc_main as default
};
